import { render, staticRenderFns } from "./FormAreaProducts.vue?vue&type=template&id=6c44c864&scoped=true"
import script from "./FormAreaProducts.vue?vue&type=script&lang=js"
export * from "./FormAreaProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44c864",
  null
  
)

export default component.exports